import { Injectable, inject } from '@angular/core';
import {divIcon, LatLng, LatLngBounds, Marker, marker, polyline, Polyline, popup} from 'leaflet';
import {LorenLayer} from '../../interfaces/loren-layer.interface';
import {LorenLayerService} from '../../loren-layer.service';
import {map} from 'rxjs/operators';
import {forkJoin, Observable} from 'rxjs';
import {LorenLayerItem} from '../../interfaces/loren-layer-item.interface';
import {LorenLayerSelectionResponse} from '../../interfaces/loren-layer-selection-response.interface';

@Injectable({
    providedIn: 'root'
})
export class LorenLayerUtilsService {
    private layerService = inject(LorenLayerService);


    handleLayerSelection(selectedLayers: LorenLayer[], currentBounds: LatLngBounds, zoom: number): Observable<LorenLayerSelectionResponse> {
        const northEast = currentBounds.getNorthWest();
        const southEast = currentBounds.getSouthEast();
        const requests: Observable<LorenLayerItem>[] = [];

        selectedLayers.forEach(layer => {
            requests.push(this.layerService.getLayerItems(layer.id, northEast.lat, northEast.lng, southEast.lat, southEast.lng, zoom));
        });

        return forkJoin(requests).pipe(map(response => {
            const markersData: Marker[] = [];
            const polylinesData: Polyline[] = [];

            const layerSelectionResponse: LorenLayerSelectionResponse = {
                polylines: [],
                markers: []
            };

            response.forEach((res, index) => {
                if (res.points.length > 0) {
                    markersData.push(...this.prepareLayerPoints(res, selectedLayers[index].pointDefaultIcon));
                }

                if (res.polylines.length > 0) {
                    polylinesData.push(...this.prepareLayerPolylines(res, selectedLayers[index].lineColor));
                }
            });

            layerSelectionResponse.markers = markersData;
            layerSelectionResponse.polylines = polylinesData;

            return layerSelectionResponse;
        }));
    }

    private prepareLayerPoints(res: LorenLayerItem, pointLayerIcon: string): Marker[] {
        const markersData: Marker[] = [];

        res.points.forEach(p => {
            const image = pointLayerIcon ? `/assets/icons/${pointLayerIcon}` : '/icon-72x72.png';
            const icon = divIcon({
                className: 'custom-div-icon',
                html: `<div class='marker-pin'></div><img src=${image}>`,
                iconSize: [30, 42],
                iconAnchor: [15, 42]
            });

            const mapMarker = marker(new LatLng(p.coordinates.lat, p.coordinates.lng), {
                icon,
            });

            const popupContent = `<h2>${p.name}</h2><h4>${p.description}</h4>`;

            if (p.name || p.description) {
                mapMarker.bindPopup(
                    popupContent,
                    {autoClose: true}
                );
            }

            markersData.push(mapMarker);
        });

        return markersData;
    }

    // remove color property later
    private prepareLayerPolylines(res: LorenLayerItem, color?: string): Polyline[] {
        const polylinesData: Polyline[] = [];

        res.polylines.forEach((x) => {
            const pol = polyline(x.points.map(p => ({lat: p.lat, lng: p.lng})), {stroke: true, color});
            const polyPopup = popup({ autoClose: false });

            polyPopup.setContent(`<h2>${x.name}</h2><h4>${x.description}</h4>`);
            pol.bindPopup(polyPopup);

            polylinesData.push(pol);
        });

        return polylinesData;
    }
}
